import React from 'react';

const NextIcon = () => (
    <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.16822 1.66333C0.16822 1.82365 0.24838 2.00401 0.36862 2.12425L8.24437 10L0.36862 17.8758C0.24838 17.996 0.16822 18.1764 0.16822 18.3367C0.16822 18.497 0.24838 18.6774 0.36862 18.7976L1.37062 19.7996C1.49086 19.9198 1.67123 20 1.83155 20C1.99187 20 2.17223 19.9198 2.29247 19.7996L11.6311 10.4609C11.7514 10.3407 11.8315 10.1603 11.8315 10C11.8315 9.83968 11.7514 9.65932 11.6311 9.53908L2.29247 0.200401C2.17223 0.0801603 1.99187 0 1.83155 0C1.67123 0 1.49086 0.0801603 1.37062 0.200401L0.36862 1.2024C0.24838 1.32265 0.16822 1.48297 0.16822 1.66333Z" fill="white" />
    </svg>
);

export default NextIcon;
